import { render, staticRenderFns } from "./companyDevelopt.vue?vue&type=template&id=5f37221f&scoped=true"
import script from "./companyDevelopt.vue?vue&type=script&lang=js"
export * from "./companyDevelopt.vue?vue&type=script&lang=js"
import style0 from "./companyDevelopt.vue?vue&type=style&index=0&id=5f37221f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f37221f",
  null
  
)

export default component.exports